const A = {
  "1-1": {
    title: "1/1 (Square)",
    value: "1/1"
  },
  "3-4": {
    title: "3/4",
    value: "3/4"
  },
  "4-3": {
    title: "4/3",
    value: "4/3"
  },
  "4-5": {
    title: "4/5",
    value: "4/5"
  },
  "9-16": {
    title: "9/16 (Portrait)",
    value: "9/16"
  },
  "11-12": {
    title: "11/12",
    value: "11/12"
  },
  "12-13": {
    title: "12/13 (PDP)",
    value: "12/13"
  },
  "16-9": {
    title: "16/9 (Landscape)",
    value: "16/9"
  },
  "7-2": {
    title: "3.5/1 (Ultra Wide)",
    value: "7/2"
  },
  _square: {
    title: "square",
    value: "1/1"
  },
  _landscape: {
    title: "landscape",
    value: "16/9"
  }
}, _ = {
  default: {
    title: "Default",
    literalValue: 0,
    value: "0rem"
  },
  sm: {
    title: "SM - Mobile (<= 640px)",
    literalValue: 640,
    value: "40rem"
  },
  md: {
    title: "MD - Tablet (<= 768px)",
    literalValue: 768,
    value: "48rem"
  },
  lg: {
    title: "LG - Desktop (> 1024px)",
    literalValue: 1024,
    value: "64rem"
  },
  xl: {
    title: "XL - Wide Screen (> 1280px)",
    literalValue: 1280,
    value: "80rem"
  },
  "2xl": {
    title: "2XL - Ultra Wide (> 1536px)",
    literalValue: 1536,
    value: "96rem"
  },
  _xsm: {
    title: "XSM",
    literalValue: 376,
    value: "23.5rem"
  },
  _smd: {
    title: "SMD",
    literalValue: 576,
    value: "48rem"
  },
  _mlg: {
    title: "MLG",
    literalValue: 1024,
    value: "64rem"
  }
}, H = {
  primary: {
    title: "Primary - Dark Beige",
    value: "#76695D"
  },
  secondary: {
    title: "Secondary - Charcoal",
    value: "#2b2b2b"
  },
  "primary-900": {
    title: "Primary - Dark Beige 90%",
    value: "#84786D"
  },
  "primary-800": {
    title: "Primary - Dark Beige 80%",
    value: "#91877D"
  },
  "primary-700": {
    title: "Primary - Dark Beige 70%",
    value: "#9F968E"
  },
  "primary-600": {
    title: "Primary - Dark Beige 60%",
    value: "#ADA59E"
  },
  "primary-500": {
    title: "Primary - Dark Beige 50%",
    value: "#BAB4AE"
  },
  "primary-400": {
    title: "Primary - Dark Beige 40%",
    value: "#C8C3BE"
  },
  "primary-300": {
    title: "Primary - Dark Beige 30%",
    value: "#D6D2CE"
  },
  "primary-200": {
    title: "Primary - Dark Beige 20%",
    value: "#E4E1DF"
  },
  "primary-150": {
    title: "Primary - Dark Beige 15%",
    value: "#EAE9E7"
  },
  "primary-100": {
    title: "Primary - Dark Beige 10%",
    value: "#F1F0EF"
  },
  tertiary: {
    title: "Tertiary - Beige",
    value: "#dfd8cf"
  },
  quaternary: {
    title: "Quaternary - Warm Grey",
    value: "#aba49c"
  },
  warning: {
    title: "Warning - Salmon",
    value: "#9c4529"
  },
  success: {
    title: "Success - Warm Green",
    value: "#5D7E5E"
  },
  neutral: {
    title: "Neutral - Off White",
    value: "#f7f7f7"
  },
  "neutral-alt": {
    title: "Neutral Alt - Porcelain",
    value: "#fbf9f7"
  },
  white: {
    title: "White",
    value: "#fff"
  },
  black: {
    title: "Black",
    value: "#000"
  },
  transparent: {
    title: "Transparent",
    value: "transparent"
  },
  current: {
    title: "Current",
    value: "currentColor"
  },
  canvas: {
    title: "Canvas",
    value: "#E6E3E1"
  },
  "_dark-grey": {
    title: "Deprecated - Dark Grey",
    value: "#c0c0c0"
  },
  "_warm-grey": {
    title: "Deprecated - Warm Grey",
    value: "#968d84"
  },
  "_light-green": {
    title: "Deprecated - light-green",
    value: "rgba(196, 196, 196, 0.1)"
  },
  "_pale-green": {
    title: "Deprecated - pale-green",
    value: "#86a785"
  },
  "_warm-green": {
    title: "Deprecated - warm-green",
    value: "#567556"
  },
  "_light-orange": {
    title: "Deprecated - light-orange",
    value: "#FF9C64"
  },
  "_transparent-green": {
    title: "Deprecated - transparent-green",
    value: "rgba(54, 68, 54, .2)"
  },
  "_transparent-light": {
    title: "Deprecated - transparent-light",
    value: "rgba(244, 241, 238, 0)"
  },
  "_transparent-beige": {
    title: "Deprecated - transparent-beige",
    value: "rgba(87, 85, 81, 0)"
  },
  "_transparent-white": {
    title: "Deprecated - transparent-white",
    value: "rgba(255, 255, 255, 0)"
  },
  _current: {
    title: "Deprecated - current",
    value: "currentColor"
  },
  _scorpion: {
    title: "Deprecated - scorpion",
    value: "#5f5f5f"
  },
  _beige: {
    title: "Deprecated - beige",
    value: "#dfd8cf"
  },
  _dark: {
    title: "Deprecated - dark",
    value: "#2b2b2b"
  },
  _green: {
    title: "Deprecated - green",
    value: "#364436"
  },
  _grey: {
    title: "Deprecated - grey",
    value: "#aba49c"
  },
  _light: {
    title: "Deprecated - light",
    value: "#f4f1ee"
  },
  _lighter: {
    title: "Deprecated - lighter",
    value: "#fbf9f7"
  },
  _lightest: {
    title: "Deprecated - lightest",
    value: "#FFF"
  },
  _orange: {
    title: "Deprecated - orange",
    value: "#ba5c27"
  },
  _charcoal: {
    title: "Deprecated - charcoal",
    value: "#2b2b2b"
  }
}, $ = {
  full: {
    title: "100%",
    literalValue: "full",
    value: "100%"
  },
  "3/4": {
    title: "3/4 (75%)",
    value: "75%",
    literalValue: 0.75
  },
  "2/3": {
    title: "2/3 (66.67%)",
    value: "66.66666666666666%",
    literalValue: 0.6666666666666666
  },
  "1/2": {
    title: "1/2 (50%)",
    value: "50%",
    literalValue: 0.5
  },
  "1/3": {
    title: "1/3 (33.33%)",
    value: "33.33333333333333%",
    literalValue: 0.3333333333333333
  },
  "1/4": {
    title: "1/4 (25%)",
    value: "25%",
    literalValue: 0.25
  },
  "full-vw": {
    title: "Full Viewport Width",
    literalValue: "100vw",
    value: "100vw"
  },
  "full-vh": {
    title: "Full Viewport Height",
    literalValue: "100vh",
    value: "100vh"
  },
  _thumbnail: {
    title: "Thumbnail",
    literalValue: "11.28%",
    value: "11.28%"
  },
  "_2/4": {
    title: "Half",
    value: "50%",
    literalValue: 0.5
  },
  "_1/5": {
    title: "1/5 (20%)",
    value: "20%",
    literalValue: 0.2
  },
  "_2/5": {
    title: "2/5 (40%)",
    value: "40%",
    literalValue: 0.4
  },
  "_3/5": {
    title: "3/5 (60%)",
    value: "60%",
    literalValue: 0.6
  },
  "_4/5": {
    title: "4/5 (80%)",
    value: "80%",
    literalValue: 0.8
  },
  "_1/6": {
    title: "1/6 (16.66%)",
    value: "16.666666666666664%",
    literalValue: 0.16666666666666666
  },
  "_2/6": {
    title: "2/6 (33.33%)",
    value: "33.33333333333333%",
    literalValue: 0.3333333333333333
  },
  "_3/6": {
    title: "3/6 (50%)",
    value: "50%",
    literalValue: 0.5
  },
  "_4/6": {
    title: "4/6 (66.66%)",
    value: "66.66666666666666%",
    literalValue: 0.6666666666666666
  },
  "_5/6": {
    title: "5/6 (83.33%)",
    value: "83.33333333333334%",
    literalValue: 0.8333333333333334
  },
  "_1/7": {
    title: "1/7 (14.28%)",
    value: "14.285714285714285%",
    literalValue: 0.14285714285714285
  },
  "_1/8": {
    title: "1/8 (12.5%)",
    value: "12.5%",
    literalValue: 0.125
  },
  "_1/9": {
    title: "1/9 (11.11%)",
    value: "11.11111111111111%",
    literalValue: 0.1111111111111111
  },
  "_4/9": {
    title: "4/9 (44.4%)",
    value: "44.44444444444444%",
    literalValue: 0.4444444444444444
  },
  "_1/10": {
    title: "1/10 (10%)",
    value: "10%",
    literalValue: 0.1
  },
  "_2/10": {
    title: "2/10 (20%)",
    value: "20%",
    literalValue: 0.2
  },
  "_4/10": {
    title: "4/10 (40%)",
    value: "40%",
    literalValue: 0.4
  },
  "_5/10": {
    title: "5/10 (50%)",
    value: "50%",
    literalValue: 0.5
  },
  "_6/10": {
    title: "6/10 (60%)",
    value: "60%",
    literalValue: 0.6
  },
  "_7/10": {
    title: "%",
    value: "70%",
    literalValue: 0.7
  },
  "_8/10": {
    title: "8/10 (80%)",
    value: "80%",
    literalValue: 0.8
  },
  "_9/10": {
    title: "9/10 (90%)",
    value: "90%",
    literalValue: 0.9
  },
  "_1/11": {
    title: "1/11 (9.09%)",
    value: "9.090909090909092%",
    literalValue: 0.09090909090909091
  },
  "_5/11": {
    title: "5/11 (45.45%)",
    value: "45.45454545454545%",
    literalValue: 0.45454545454545453
  },
  "_1/12": {
    title: "1/2 (8.3%)",
    value: "8.333333333333332%",
    literalValue: 0.08333333333333333
  },
  "_2/12": {
    title: "2/12 (16.6%)",
    value: "16.666666666666664%",
    literalValue: 0.16666666666666666
  },
  "_5/12": {
    title: "5/12 (41.66%)",
    value: "41.66666666666667%",
    literalValue: 0.4166666666666667
  },
  "_6/12": {
    title: "6/12 (50%)",
    value: "50%",
    literalValue: 0.5
  }
}, E = {
  caption: {
    title: "Caption (12px)",
    literalValue: 12,
    value: "0.75rem"
  },
  hint: {
    title: "Hint (14px)",
    literalValue: 14,
    value: "0.875rem"
  },
  body: {
    title: "Body (16px)",
    literalValue: 16,
    value: "1rem"
  },
  h5: {
    title: "Heading 5 (12px)",
    literalValue: 12,
    value: "0.75rem"
  },
  h4: {
    title: "Heading 4 (20px)",
    literalValue: 20,
    value: "1.25rem"
  },
  h3: {
    title: "Heading 3 (24px)",
    literalValue: 24,
    value: "1.5rem"
  },
  h2: {
    title: "Heading 2 (28px)",
    literalValue: 28,
    value: "1.75rem"
  },
  h1: {
    title: "Heading 1 (38px)",
    literalValue: 38,
    value: "2.375rem"
  }
}, F = {
  display: {
    title: "Title (Harriet Display)",
    value: ["Harriet Display", "sans-serif"]
  },
  body: {
    title: "Body Copy (Graphik)",
    value: ["Graphik", "sans-serif"]
  }
}, L = {
  heading: {
    title: "Heading",
    value: "0.07em"
  },
  body: {
    title: "Body",
    value: "0"
  }
}, I = {
  h1: {
    title: "Heading 1 (56/64 - 114%)",
    value: "1.142857142857143"
  },
  h2: {
    title: "Heading 2 (40/48 - 120%)",
    value: "1.2"
  },
  h3: {
    title: "Heading 3 (32/40 - 125%)",
    value: "1.25"
  },
  h4: {
    title: "Heading 4 (24/32 - 133%)",
    value: "1.333333333333333"
  },
  h5: {
    title: "Heading 5 (12/28 - 233%)",
    value: "2.333333333333333"
  },
  body: {
    title: "Body (16/28 - 175%)",
    value: "1.75"
  },
  hint: {
    title: "Hint (14/24 - 171%)",
    value: "1.714285714285714"
  },
  caption: {
    title: "Caption (12/20 - 166%)",
    value: "1.666666666666667"
  },
  input: {
    title: "Input (16/16 - 100%)",
    value: "1"
  },
  double: {
    title: "Double (16/32 - 200%)",
    value: "2"
  },
  triple: {
    title: "Triple (16/48 - 400%)",
    value: "3"
  }
}, x = {
  auto: {
    title: "Auto",
    value: "auto"
  },
  zero: {
    title: "No Spacing",
    literalValue: 0,
    value: "0rem"
  },
  nano: {
    title: "Nano (2px)",
    literalValue: 2,
    value: "0.125rem"
  },
  pico: {
    title: "Pico (4px)",
    literalValue: 4,
    value: "0.25rem"
  },
  micro: {
    title: "Micro (8px)",
    literalValue: 8,
    value: "0.5rem"
  },
  mini: {
    title: "Mini (16px)",
    literalValue: 16,
    value: "1rem"
  },
  midi: {
    title: "Midi (24px)",
    literalValue: 24,
    value: "1.5rem"
  },
  maxi: {
    title: "Maxi (32px)",
    literalValue: 32,
    value: "2rem"
  },
  mega: {
    title: "Mega (48px)",
    literalValue: 48,
    value: "3rem"
  },
  giga: {
    title: "Giga (64px)",
    literalValue: 64,
    value: "4rem"
  },
  tera: {
    title: "Tera (80px)",
    literalValue: 80,
    value: "5rem"
  },
  peta: {
    title: "Peta (120px)",
    literalValue: 120,
    value: "7.5rem"
  },
  exa: {
    title: "Exa (160px)",
    literalValue: 160,
    value: "10rem"
  },
  _none: {
    title: "None",
    literalValue: "none",
    value: "none"
  },
  _auto: {
    title: "auto",
    literalValue: "auto",
    value: "auto"
  },
  _0: {
    title: "0rem",
    literalValue: 0,
    value: "0rem"
  },
  "_0-1": {
    title: "0.0625rem",
    literalValue: 1,
    value: "0.0625rem"
  },
  "_0-2": {
    title: "0.125rem",
    literalValue: 2,
    value: "0.125rem"
  },
  "_0-3": {
    title: "0.1875rem",
    literalValue: 3,
    value: "0.1875rem"
  },
  "_0-4": {
    title: "0.25rem",
    literalValue: 4,
    value: "0.25rem"
  },
  "_0-5": {
    title: "0.3125rem",
    literalValue: 5,
    value: "0.3125rem"
  },
  "_0-6": {
    title: "0.375rem",
    literalValue: 6,
    value: "0.375rem"
  },
  "_0-7": {
    title: "0.4375rem",
    literalValue: 7,
    value: "0.4375rem"
  },
  "_0-8": {
    title: "0.5rem",
    literalValue: 8,
    value: "0.5rem"
  },
  "_0-9": {
    title: "0.5625rem",
    literalValue: 9,
    value: "0.5625rem"
  },
  _1: {
    title: "0.625rem",
    literalValue: 10,
    value: "0.625rem"
  },
  "_1-1": {
    title: "0.6875rem",
    literalValue: 11,
    value: "0.6875rem"
  },
  "_1-2": {
    title: "0.75rem",
    literalValue: 12,
    value: "0.75rem"
  },
  "_1-4": {
    title: "0.875rem",
    literalValue: 14,
    value: "0.875rem"
  },
  "_1-6": {
    title: "1rem",
    literalValue: 16,
    value: "1rem"
  },
  "_1-8": {
    title: "1.125rem",
    literalValue: 18,
    value: "1.125rem"
  },
  _2: {
    title: "1.25rem",
    literalValue: 20,
    value: "1.25rem"
  },
  "_2-2": {
    title: "1.375rem",
    literalValue: 22,
    value: "1.375rem"
  },
  "_2-4": {
    title: "1.5rem",
    literalValue: 24,
    value: "1.5rem"
  },
  "_2-6": {
    title: "1.625rem",
    literalValue: 26,
    value: "1.625rem"
  },
  "_2-8": {
    title: "1.75rem",
    literalValue: 28,
    value: "1.75rem"
  },
  _3: {
    title: "1.875rem",
    literalValue: 30,
    value: "1.875rem"
  },
  "_3-2": {
    title: "2rem",
    literalValue: 32,
    value: "2rem"
  },
  "_3-3": {
    title: "2.0625rem",
    literalValue: 33,
    value: "2.0625rem"
  },
  "_3-4": {
    title: "2.125rem",
    literalValue: 34,
    value: "2.125rem"
  },
  "_3-6": {
    title: "2.25rem",
    literalValue: 36,
    value: "2.25rem"
  },
  _4: {
    title: "2.5rem",
    literalValue: 40,
    value: "2.5rem"
  },
  "_4-2": {
    title: "2.625rem",
    literalValue: 42,
    value: "2.625rem"
  },
  "_4-8": {
    title: "3rem",
    literalValue: 48,
    value: "3rem"
  },
  _5: {
    title: "3.125rem",
    literalValue: 50,
    value: "3.125rem"
  },
  "_5-6": {
    title: "3.5rem",
    literalValue: 56,
    value: "3.5rem"
  },
  _6: {
    title: "3.75rem",
    literalValue: 60,
    value: "3.75rem"
  },
  "_6-2": {
    title: "3.875rem",
    literalValue: 62,
    value: "3.875rem"
  },
  "_6-4": {
    title: "4rem",
    literalValue: 64,
    value: "4rem"
  },
  "_6-7": {
    title: "4.1875rem",
    literalValue: 67,
    value: "4.1875rem"
  },
  _7: {
    title: "4.375rem",
    literalValue: 70,
    value: "4.375rem"
  },
  "_7-2": {
    title: "4.5rem",
    literalValue: 72,
    value: "4.5rem"
  },
  "_7-6": {
    title: "4.75rem",
    literalValue: 76,
    value: "4.75rem"
  },
  "_7-8": {
    title: "4.875rem",
    literalValue: 78,
    value: "4.875rem"
  },
  _8: {
    title: "5rem",
    literalValue: 80,
    value: "5rem"
  },
  "_8-6": {
    title: "5.375rem",
    literalValue: 86,
    value: "5.375rem"
  },
  "_8-8": {
    title: "5.5rem",
    literalValue: 88,
    value: "5.5rem"
  },
  _9: {
    title: "5.625rem",
    literalValue: 90,
    value: "5.625rem"
  },
  "_9-2": {
    title: "5.75rem",
    literalValue: 92,
    value: "5.75rem"
  },
  "_9-6": {
    title: "6rem",
    literalValue: 96,
    value: "6rem"
  },
  _10: {
    title: "6.25rem",
    literalValue: 100,
    value: "6.25rem"
  },
  "_10-4": {
    title: "6.5rem",
    literalValue: 104,
    value: "6.5rem"
  },
  "_10-6": {
    title: "6.625rem",
    literalValue: 106,
    value: "6.625rem"
  },
  _11: {
    title: "6.875rem",
    literalValue: 110,
    value: "6.875rem"
  },
  "_11-2": {
    title: "7rem",
    literalValue: 112,
    value: "7rem"
  },
  _12: {
    title: "7.5rem",
    literalValue: 120,
    value: "7.5rem"
  },
  "_12-1": {
    title: "7.5625rem",
    literalValue: 121,
    value: "7.5625rem"
  },
  "_12-2": {
    title: "7.625rem",
    literalValue: 122,
    value: "7.625rem"
  },
  "_12-3": {
    title: "7.6875rem",
    literalValue: 123,
    value: "7.6875rem"
  },
  "_12-8": {
    title: "8rem",
    literalValue: 128,
    value: "8rem"
  },
  _13: {
    title: "8.125rem",
    literalValue: 130,
    value: "8.125rem"
  },
  "_13-6": {
    title: "8.5rem",
    literalValue: 136,
    value: "8.5rem"
  },
  _14: {
    title: "8.75rem",
    literalValue: 140,
    value: "8.75rem"
  },
  "_14-4": {
    title: "9rem",
    literalValue: 144,
    value: "9rem"
  },
  _15: {
    title: "9.375rem",
    literalValue: 150,
    value: "9.375rem"
  },
  "_15-1": {
    title: "9.4375rem",
    literalValue: 151,
    value: "9.4375rem"
  },
  _16: {
    title: "10rem",
    literalValue: 160,
    value: "10rem"
  },
  "_16-8": {
    title: "10.5rem",
    literalValue: 168,
    value: "10.5rem"
  },
  "_17-6": {
    title: "11rem",
    literalValue: 176,
    value: "11rem"
  },
  _18: {
    title: "11.25rem",
    literalValue: 180,
    value: "11.25rem"
  },
  _19: {
    title: "11.875rem",
    literalValue: 190,
    value: "11.875rem"
  },
  _20: {
    title: "12.5rem",
    literalValue: 200,
    value: "12.5rem"
  },
  "_20-8": {
    title: "13rem",
    literalValue: 208,
    value: "13rem"
  },
  "_21-3": {
    title: "13.3125rem",
    literalValue: 213,
    value: "13.3125rem"
  },
  _22: {
    title: "13.75rem",
    literalValue: 220,
    value: "13.75rem"
  },
  "_23-2": {
    title: "14.5rem",
    literalValue: 232,
    value: "14.5rem"
  },
  _25: {
    title: "15.625rem",
    literalValue: 250,
    value: "15.625rem"
  },
  "_27-2": {
    title: "17rem",
    literalValue: 272,
    value: "17rem"
  },
  _28: {
    title: "17.5rem",
    literalValue: 280,
    value: "17.5rem"
  },
  "_28-8": {
    title: "18rem",
    literalValue: 288,
    value: "18rem"
  },
  "_29-2": {
    title: "18.25rem",
    literalValue: 292,
    value: "18.25rem"
  },
  _30: {
    title: "18.75rem",
    literalValue: 300,
    value: "18.75rem"
  },
  _32: {
    title: "20rem",
    literalValue: 320,
    value: "20rem"
  },
  _33: {
    title: "20.625rem",
    literalValue: 330,
    value: "20.625rem"
  },
  "_33-6": {
    title: "21rem",
    literalValue: 336,
    value: "21rem"
  },
  _36: {
    title: "22.5rem",
    literalValue: 360,
    value: "22.5rem"
  },
  "_37-6": {
    title: "23.5rem",
    literalValue: 376,
    value: "23.5rem"
  },
  _40: {
    title: "25rem",
    literalValue: 400,
    value: "25rem"
  },
  _41: {
    title: "25.625rem",
    literalValue: 410,
    value: "25.625rem"
  },
  _42: {
    title: "26.25rem",
    literalValue: 420,
    value: "26.25rem"
  },
  _43: {
    title: "26.875rem",
    literalValue: 430,
    value: "26.875rem"
  },
  "_43-6": {
    title: "27.25rem",
    literalValue: 436,
    value: "27.25rem"
  },
  _44: {
    title: "27.5rem",
    literalValue: 440,
    value: "27.5rem"
  },
  _45: {
    title: "28.125rem",
    literalValue: 450,
    value: "28.125rem"
  },
  "_45-6": {
    title: "28.5rem",
    literalValue: 456,
    value: "28.5rem"
  },
  _47: {
    title: "29.375rem",
    literalValue: 470,
    value: "29.375rem"
  },
  _49: {
    title: "30.625rem",
    literalValue: 490,
    value: "30.625rem"
  },
  _50: {
    title: "31.25rem",
    literalValue: 500,
    value: "31.25rem"
  },
  "_59-2": {
    title: "37rem",
    literalValue: 592,
    value: "37rem"
  },
  _60: {
    title: "37.5rem",
    literalValue: 600,
    value: "37.5rem"
  },
  _63: {
    title: "39.375rem",
    literalValue: 630,
    value: "39.375rem"
  },
  _66: {
    title: "41.25rem",
    literalValue: 660,
    value: "41.25rem"
  },
  _70: {
    title: "43.75rem",
    literalValue: 700,
    value: "43.75rem"
  },
  _72: {
    title: "45rem",
    literalValue: 720,
    value: "45rem"
  },
  _77: {
    title: "48.125rem",
    literalValue: 770,
    value: "48.125rem"
  },
  _80: {
    title: "50rem",
    literalValue: 800,
    value: "50rem"
  },
  _90: {
    title: "56.25rem",
    literalValue: 900,
    value: "56.25rem"
  },
  _100: {
    title: "62.5rem",
    literalValue: 1e3,
    value: "62.5rem"
  },
  _120: {
    title: "75rem",
    literalValue: 1200,
    value: "75rem"
  },
  _144: {
    title: "90rem",
    literalValue: 1440,
    value: "90rem"
  }
}, y = {
  display: {
    description: null,
    group: "layout",
    mapKey: null,
    primitive: null,
    subgroup: null,
    title: "Display",
    type: "string",
    values: [
      {
        title: "Flex",
        value: "flex"
      },
      {
        title: "Grid",
        value: "grid"
      },
      {
        title: "Block",
        value: "block"
      },
      {
        title: "Inline",
        value: "inline"
      },
      {
        title: "None",
        value: "hidden"
      }
    ]
  },
  font: {
    description: null,
    group: "typography",
    mapKey: "fontFamily",
    primitive: "font",
    subgroup: null,
    title: "Font Family",
    type: "string",
    values: null
  },
  fontSize: {
    description: null,
    group: "typography",
    mapKey: "fontSize",
    primitive: "text",
    subgroup: null,
    title: "Text Size",
    type: "string",
    values: null
  },
  backgroundColour: {
    description: null,
    group: "background",
    mapKey: "colors",
    primitive: "bg",
    subgroup: null,
    title: "Background Colour",
    type: "colourToken",
    values: null
  },
  backgroundImage: {
    description: null,
    group: "background",
    mapKey: "colors",
    primitive: "bg",
    subgroup: null,
    title: "Background Image",
    type: "image",
    values: null
  },
  backgroundSize: {
    description: "Auto displays the background image at the default size, cover expands to fill width/height of container, scales to fit the outer edges without cropping or stretching",
    group: "background",
    mapKey: "colors",
    primitive: "bg",
    subgroup: null,
    title: "Background Size",
    type: "string",
    values: [
      {
        title: "Auto",
        value: "auto"
      },
      {
        title: "Contain",
        value: "contain"
      },
      {
        title: "Cover",
        value: "cover"
      }
    ]
  },
  backgroundOpacity: {
    description: "This sets the opacity of the background colour only, all child elements within remain 100% opacity",
    group: "background",
    mapKey: null,
    primitive: "bg-opacity",
    subgroup: null,
    title: "Background Opacity",
    type: "number",
    values: Array.from(new Array(11).keys()).map((e) => ({
      title: `${e * 10}`,
      literalValue: `${e / 10}`,
      value: `${e * 10}`
    }))
  },
  textColour: {
    description: null,
    group: "colours",
    mapKey: "colors",
    primitive: "text",
    subgroup: null,
    title: "Text Colour",
    type: "colourToken",
    values: null
  },
  flexDirection: {
    description: null,
    hidden: (e, l) => l[`${e}_display`] !== "flex",
    group: "layout",
    mapKey: "spacing",
    primitive: "flex",
    subgroup: null,
    title: "Flex Direction",
    type: "string",
    values: [
      {
        title: "Row",
        value: "row"
      },
      {
        title: "Column",
        value: "column"
      }
    ]
  },
  justifyContent: {
    description: "If you are using a flex direction of 'row', it will align items horizontally. If using 'column', it will align items vertically.",
    group: "layout",
    hidden: (e, l) => l[`${e}_display`] !== "flex",
    mapKey: null,
    primitive: "justify",
    subgroup: null,
    title: "Justify Content",
    type: "string",
    values: [
      {
        title: "Start",
        value: "start"
      },
      {
        title: "Center",
        value: "center"
      },
      {
        title: "End",
        value: "end"
      }
    ]
  },
  alignItems: {
    description: "If you are using a flex direction of 'row', it will align items vertically. If using 'column', it will align items horizontally.",
    group: "layout",
    hidden: (e, l) => l[`${e}_display`] !== "flex",
    mapKey: null,
    primitive: "items",
    subgroup: null,
    title: "Align Items",
    type: "string",
    values: [
      {
        title: "Start",
        value: "start"
      },
      {
        title: "Center",
        value: "center"
      },
      {
        title: "End",
        value: "end"
      }
    ]
  },
  order: {
    description: null,
    group: "layout",
    hidden: (e, l) => l[`${e}_display`] !== "flex",
    mapKey: null,
    primitive: "order",
    subgroup: null,
    title: "Order",
    type: "number",
    values: Array.from(new Array(10).keys()).map((e) => ({
      title: `${e}`,
      value: e
    }))
  },
  gridColumns: {
    description: null,
    group: "layout",
    hidden: (e, l) => l[`${e}_display`] !== "grid",
    mapKey: null,
    primitive: "grid-cols",
    subgroup: null,
    title: "Grid Columns",
    type: "number",
    values: Array.from(new Array(12).keys()).map((e) => ({
      title: `${e + 1}`,
      value: e + 1
    }))
  },
  gridGap: {
    description: null,
    group: "layout",
    hidden: (e, l) => l[`${e}_display`] !== "grid",
    mapKey: "spacing",
    primitive: "gap",
    subgroup: null,
    title: "Grid Gap",
    type: "string",
    values: null
  },
  opacity: {
    description: "Values are in %",
    group: "colours",
    mapKey: null,
    primitive: "opacity",
    subgroup: null,
    title: "Opacity",
    type: "number",
    values: Array.from(new Array(11).keys()).map((e) => ({
      title: `${e * 10}`,
      literalValue: `${e / 10}`,
      value: `${e * 10}`
    }))
  },
  padding: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "p",
    subgroup: null,
    title: "Padding",
    type: "string",
    values: null
  },
  paddingBottom: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "pb",
    subgroup: null,
    title: "Padding Bottom",
    type: "string",
    values: null
  },
  paddingLeft: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "pl",
    subgroup: null,
    title: "Padding Left",
    type: "string",
    values: null
  },
  paddingRight: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "pr",
    subgroup: null,
    title: "Padding Right",
    type: "string",
    values: null
  },
  paddingTop: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "pt",
    subgroup: null,
    title: "Padding Top",
    type: "string",
    values: null
  },
  margin: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "m",
    subgroup: null,
    title: "Margin",
    type: "string",
    values: null
  },
  marginBottom: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "mb",
    subgroup: null,
    title: "Margin Bottom",
    type: "string",
    values: null
  },
  marginLeft: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "ml",
    subgroup: null,
    title: "Margin Left",
    type: "string",
    values: null
  },
  marginRight: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "mr",
    subgroup: null,
    title: "Margin Right",
    type: "string",
    values: null
  },
  marginTop: {
    description: null,
    group: "spacing",
    mapKey: "spacing",
    primitive: "mt",
    subgroup: null,
    title: "Margin Top",
    type: "string",
    values: null
  },
  position: {
    description: null,
    group: "layout",
    mapKey: null,
    primitive: null,
    subgroup: null,
    title: "Position",
    type: "string",
    values: [
      {
        title: "Static (Default)",
        value: "static"
      },
      {
        title: "Absolute",
        value: "absolute"
      },
      {
        title: "Fixed",
        value: "fixed"
      },
      {
        title: "Relative",
        value: "relative"
      },
      {
        title: "Sticky",
        value: "sticky"
      }
    ]
  },
  bottom: {
    description: null,
    group: "layout",
    hidden: (e, l) => ["static", void 0].includes(l[`${e}_position`]),
    mapKey: "spacing",
    primitive: "bottom",
    subgroup: null,
    title: "Bottom",
    type: "string",
    values: null
  },
  left: {
    description: null,
    group: "layout",
    hidden: (e, l) => ["static", void 0].includes(l[`${e}_position`]),
    mapKey: "spacing",
    primitive: "left",
    subgroup: null,
    title: "Left",
    type: "string",
    values: null
  },
  right: {
    description: null,
    group: "layout",
    hidden: (e, l) => ["static", void 0].includes(l[`${e}_position`]),
    mapKey: "spacing",
    primitive: "right",
    subgroup: null,
    title: "Right",
    type: "string",
    values: null
  },
  top: {
    description: null,
    group: "layout",
    hidden: (e, l) => ["static", void 0].includes(l[`${e}_position`]),
    mapKey: "spacing",
    primitive: "top",
    subgroup: null,
    title: "Top",
    type: "string",
    values: null
  },
  maxWidth: {
    description: "This is the maximum width an object can be, but it can be any value lower than this",
    group: "dimensions",
    mapKey: "breakpoints",
    primitive: "max-w",
    subgroup: null,
    title: "Max Width",
    type: "string",
    values: null
  },
  maxHeight: {
    description: "This is the maximum height an object can be, but the actual height can be any value lower than this",
    group: "dimensions",
    mapKey: null,
    primitive: "max-h",
    subgroup: null,
    title: "Max Height",
    type: "string",
    values: [
      {
        title: "50vh",
        value: "50vh"
      },
      {
        title: "60vh",
        value: "60vh"
      },
      {
        title: "70vh",
        value: "70vh"
      },
      {
        title: "80vh",
        value: "80vh"
      },
      {
        title: "90vh",
        value: "90vh"
      },
      {
        title: "100vh",
        value: "100vh"
      }
    ]
  },
  width: {
    description: null,
    group: "dimensions",
    mapKey: "dimensions",
    primitive: "w",
    subgroup: null,
    title: "Width",
    type: "string",
    values: null
  },
  height: {
    description: null,
    group: "dimensions",
    mapKey: "dimensions",
    primitive: "h",
    subgroup: null,
    title: "Height",
    type: "string",
    values: null
  },
  letterSpacing: {
    description: null,
    group: "typography",
    mapKey: "letterSpacing",
    primitive: "tracking",
    subgroup: null,
    title: "Letter Spacing/Tracking",
    type: "string",
    values: null
  },
  lineHeight: {
    description: null,
    group: "typography",
    mapKey: "lineHeight",
    primitive: "leading",
    subgroup: null,
    title: "Line Height/Leading",
    type: "string",
    values: null
  },
  aspectRatio: {
    description: null,
    group: "layout",
    mapKey: "aspectRatio",
    primitive: "aspect",
    subgroup: null,
    title: "Aspect Ratio",
    type: "string",
    values: null
  },
  textAlignment: {
    description: null,
    group: "typography",
    mapKey: "textAlign",
    primitive: "text",
    subgroup: null,
    title: "Text Alignment",
    type: "string",
    values: [
      {
        title: "Left",
        value: "left"
      },
      {
        title: "Center",
        value: "center"
      },
      {
        title: "Right",
        value: "right"
      },
      {
        title: "Justify",
        value: "justify"
      }
    ]
  },
  zIndex: {
    description: "Setting the z-index allows you to stack absolutely positioned elements — the higher the number, the higher in the stack the element is. Start small and work your way up.",
    group: "layout",
    mapKey: null,
    primitive: "z",
    subgroup: null,
    title: "Z-Index",
    type: "number",
    values: Array.from(new Array(10).keys()).map((e) => ({
      title: `${(e + 1) * 10}`,
      value: (e + 1) * 10
    }))
  },
  state: {
    description: "State modifiers (pseudo-classes) are used to style an element in specific states.",
    group: "state",
    mapKey: null,
    primitive: null,
    subgroup: null,
    title: "State",
    type: "string",
    values: [
      {
        title: "Interaction: Hover",
        value: "hover"
      },
      {
        title: "Interaction: Focus",
        value: "focus"
      },
      {
        title: "Interaction: Active",
        value: "active"
      },
      {
        title: "Position: Last",
        value: "last"
      },
      {
        title: "Position: First",
        value: "first"
      },
      {
        title: "Position: Last of type",
        value: "last-of-type"
      },
      {
        title: "Position: First of type",
        value: "first-of-type"
      },
      {
        title: "Position: Odd",
        value: "odd"
      },
      {
        title: "Position: Even",
        value: "even"
      }
    ]
  },
  descendants: {
    description: "Choosing a descendant will apply these styles to child elements within this container.",
    group: "descendants",
    mapKey: null,
    primitive: null,
    subgroup: null,
    title: "Descendants",
    type: "string",
    values: [
      {
        title: "Paragraph (<p>...</p>)",
        value: "p"
      },
      {
        title: "Div (<div>...</div>)",
        value: "div"
      }
    ]
  }
};
function z({
  hiddenTokens: e
} = {}) {
  const l = o(_, {
    ignoreDefault: !0
  }), g = o(H), m = o($), c = o(F), u = o(E), v = o(L), d = o(I), k = o(A), D = o(y.opacity.values, {
    valueType: "LITERAL"
  }), w = o(y.zIndex.values), s = {
    ...o(x),
    ...M(x, m),
    ...m,
    ...l
  };
  let V = {
    breakpoints: l,
    dimensions: m,
    screens: l,
    spacing: s,
    width: s,
    height: s,
    maxWidth: s,
    maxHeight: s,
    minWidth: s,
    minHeight: s,
    borderRadius: s,
    inset: s,
    translate: s,
    colors: g,
    fontFamily: c,
    fontSize: u,
    letterSpacing: v,
    lineHeight: d,
    aspectRatio: k,
    opacity: D,
    zIndex: w
  };
  e && (V = Object.entries(V).reduce(
    (i, [t, n]) => ({
      ...i,
      [t]: Object.entries(n).reduce(
        (r, [a, p]) => {
          if (a.startsWith("_")) {
            if (e === "REMOVE") return r;
            if (e === "NORMALISE")
              return {
                ...r,
                [a.split("_").pop()]: p
              };
          }
          return {
            ...r,
            [a]: p
          };
        },
        {}
      )
    }),
    {}
  ));
  const K = (i) => {
    var t;
    return i ? (t = y[i]) == null ? void 0 : t.primitive : null;
  }, h = (i) => Object.keys(i).filter((t) => !t.startsWith("_")), f = (i, t) => t === "default" || !t ? i : `${t}:${i}`, T = (i) => i ? h(_).reduce((t, n) => {
    const r = i.map(({ value: a }) => f(a, n));
    return [...t, ...r];
  }, []) : [], S = (i, t) => t.reduce((n, { value: r }) => {
    const a = `${i}-${r}`;
    return h(_).reduce((p, b) => [...p, f(a, b)], n);
  }, []), P = (i, t) => {
    if (!t)
      return [];
    const n = V[t];
    return n ? Object.keys(n).reduce((r, a) => h(_).reduce((p, b) => {
      const C = i == null ? a : `${i}-${a}`;
      return [...p, f(C, b)];
    }, r), []) : [];
  }, B = Object.keys(
    y
  ).reduce((t, n) => {
    const r = K(n), { values: a, mapKey: p } = y[n];
    return r == null && p == null && a ? [...t, ...T(a)] : r !== null && p == null && a ? [
      ...t,
      ...S(r, a)
    ] : [
      ...t,
      ...P(r, p)
    ];
  }, []);
  return { theme: V, safelist: B };
}
function o(e, {
  valueType: l = "VALUE",
  ignoreHidden: g = !1,
  ignoreDefault: m = !1
} = {}) {
  const c = Array.isArray(e) ? e.reduce(
    (u, v) => ({
      ...u,
      [v.title]: v
    }),
    {}
  ) : e;
  return Object.entries(c).reduce(
    (u, [v, d]) => m && v === "default" || g && v.startsWith("_") ? u : {
      ...u,
      [v]: l === "LITERAL" && d.literalValue ? d.literalValue : d.value
    },
    {}
  );
}
function M(e, l) {
  return Object.entries(e).reduce(
    (g, [m, c]) => {
      const u = Number(c.literalValue);
      return isNaN(u) ? g : {
        ...g,
        [`${m}vw`]: `${u / 10}vw`,
        [`${m}vh`]: `${u / 10}vh`
      };
    },
    { ...l }
  );
}
function W(e) {
  return e === "2xl" ? "xxl" : e;
}
function N(e) {
  return e === "xxl" ? "2xl" : e;
}
export {
  A as aspectRatios,
  _ as breakpoints,
  H as colours,
  z as createTailwindConfig,
  $ as dimensions,
  E as fontSizes,
  F as fonts,
  L as letterSpacing,
  I as lineHeights,
  N as sanityToTailwindBreakpoint,
  x as spacing,
  y as styleTranslationMap,
  W as tailwindToSanityBreakpoint
};
